/**
 * 주소(쿼리스트링)에 JSON으로 담긴 값(header-period, header-headcount, roomId 등)을 읽는다.
 * 값이 없거나 JSON이 깨져 있어도 오류를 내지 않고 null을 돌려준다(직접 JSON.parse하면 렌더 중 오류로 빈 화면이 된다).
 */
export const parseJsonParam = (value: string | null | undefined) => {
  if (!value) return null;
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
};
